@if (viewState().kind === 'success') {
  <section class="flow-resume__section" data-testid="success-state">
    <div class="flex items-start gap-3">
      <div class="flex-1">
        <h3 class="text-base font-semibold text-gray-800 flex gap-2"><activar-icon name="success_circle" /> Código aplicado</h3>
        <p class="text-sm text-gray-600">
          Estás usando el código <span class="font-mono font-semibold">{{ successCode() }}</span>.
        </p>
      </div>
      <button
        type="button"
        class="text-sm font-medium text-primary hover:underline"
        (click)="reset()"
      >
        Quitar
      </button>
    </div>
  </section>
} @else {
  <section class="flow-resume__section">
    <div class="flex items-start gap-3">
      <div class="flex-1 space-y-3">
        <div>
          <h3 class="text-base font-semibold text-gray-800 flex gap-2"> <activar-icon name="sparkles" /> ¿Tenés un código de referido?</h3>
          <p class="text-sm text-gray-500">Aplicalo ahora para que quede asociado a esta póliza.</p>
        </div>
        <div class="flex flex-col gap-1">
          <label for="referralCode" class="sr-only">Código de referido</label>
          <div class="flex gap-2">
            <input
              type="text"
              id="referralCode"
              autocomplete="off"
              class="input__base flex-1"
              [formControl]="referralCodeControl"
              [readonly]="isValidating()"
              (input)="onInput()"
              (keydown.enter)="apply()"
              [attr.aria-busy]="isValidating()"
            />
            <activar-button
              type="button"
              [text]="'Aplicar'"
              [loading]="isValidating()"
              [disabled]="isValidating()"
              (click)="apply()"
              expand="block"
            />
          </div>
          <app-input-error [control]="referralCodeControl" [submitted]="false" />
          @if (validationError()) {
            <span class="text-sm text-red-600">{{ validationError() }}</span>
          }
        </div>
      </div>
    </div>
  </section>
}
